export const IMAGES = {
	Logo: require('./img/logo.png').default,
	LightBd: require('./img/bg.jpg').default,
};
